import R from 'ramda';

export const matchImageWithBreakpoint = ({ image, currentBreakpoint }) =>
  R.or(
    R.path(
      [0, 'src'],
      R.filter(
        R.propEq('name', currentBreakpoint),
        R.propOr({ imageSrcSet: [] }, 'imageSrcSet', image),
      ),
    ),
    R.prop('imageSrc', image),
  );

export const getImages = ({ images, currentBreakpoint }) => ({
  beforeImage: matchImageWithBreakpoint({
    currentBreakpoint,
    image: R.prop('before', images),
  }),
  afterImage: matchImageWithBreakpoint({
    currentBreakpoint,
    image: R.prop('after', images),
  }),
  slideButtonImage: matchImageWithBreakpoint({
    currentBreakpoint,
    image: R.prop('slideButton', images),
  }),
});

export const getImageDimension = ({ imageSrcSet, currentBreakpoint }) =>
  R.prop(
    'dimension',
    R.find(R.propEq('name', currentBreakpoint), imageSrcSet),
  ) || R.path([0, 'xsDimension'], imageSrcSet);
